import React, { useState, useEffect } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import logowhite from "../assets/img/logo-dark.svg";
import { Icon } from "@iconify/react";

const Sidebar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  useEffect(() => {
    document.body.classList.toggle("no-scroll", sidebarOpen);
  }, [sidebarOpen]);

  const handleNavLinkClick = () => {
    setSidebarOpen(false);
    setOpenSubmenu(null);
  };

  const handleSubmenuClick = (id) => {
    setOpenSubmenu(openSubmenu === id ? null : id);
  };

  const isSubmenuItemActive = (submenu) => {
    return submenu.some((sub) => location.pathname.startsWith(sub.link));
  };

  const isPageActive = (page) => {
    const pathname = location.pathname.toLowerCase();

    if (page.submenu) {
      return isSubmenuItemActive(page.submenu);
    }

    if (page.activePaths) {
      return page.activePaths.some((path) =>
        pathname.startsWith(path.toLowerCase())
      );
    }

    return pathname.startsWith(page.link.toLowerCase());
  };

  const pages = [
    {
      id: "Dashboard",
      title: "Dashboard",
      link: "/dashboard",
      icon: "mdi:view-grid-outline",
    },
    {
      id: "Users",
      title: "Users",
      link: "/users",
      icon: "lucide:users",
      activePaths: ["/users", "/admin/view-user","/admin/character-detail"],
    },
    // {
    //   id: "ContentManagement",
    //   title: "Content Management",
    //   link: "/tales",
    //   icon: "bx:file",
    //   submenu: [
    //     { id: "Tales", title: "Tales", link: "/tales" },
    //     {
    //       id: "AIGeneratedTales",
    //       title: "AI-Generated Tales",
    //       link: "/ai-generated-tales",
    //     },
    //     { id: "Characters", title: "Characters", link: "/characters" },
    //   ],
    // },
    {
      id: "Tales",
      title: "Tales",
      link: "/tales",
      icon: "ph:scroll",
      activePaths: ["/tales", "/admin/tale-detail"],
    },
    // {
    //       id: "AIGeneratedTales",
    //       title: "AI-Generated Stories",
    //       link: "/ai-generated-tales",
    //       icon: "ph:books",
    //     },
    {
      id: "books",
      title: "Books",
      link: "/books",
      icon: "ph:books",
      activePaths: ["/books", "/admin/view-book"],
    },
    // {
    //   id: 'AnalyticsInsights',
    //   title: 'Analytics & Insights',
    //   link: '/analytics-insights',
    //   icon: 'hugeicons:analytics-down',
    // },
    // {
    //   id: 'Announcements',
    //   title: 'Announcements',
    //   link: 'javascript:void(0)',
    //   icon: 'mingcute:announcement-line',
    // },
    // {
    //   id: 'Notifications',
    //   title: 'Notifications',
    //   link: '/notifications',
    //   icon: 'ic:outline-notifications-none',
    // },
    // {
    //   id: 'FeedbackSupport',
    //   title: 'Feedback & Support',
    //   link: '/feedback-support',
    //   icon: 'fluent:person-support-20-regular',
    // },
    {
      id: 'SubscriptionManagement',
      title: 'Subscription Packages',
      link: '/subscription-packages',
      icon: 'lucide:package',
    },
    {
      id: 'Subscribers',
      title: 'Subscribers',
      link: '/subscribers',
      icon: 'ph:users-three',
    },
    // {
    //   id: "Reports",
    //   title: "Reports",
    //   link: "/reports",
    //   icon: "fluent-mdl2:report-document",
    //   activePaths: ["/reports", "/admin/report-detail"],
    // },
    {
      id: "Reports",
      title: "Reports",
      link: "/reports",
      icon: "fluent-mdl2:report-document",
      activePaths: ["/reports", "/admin/report-detail"],
      submenu: [
        { id: "Tales", title: "Tales Reports", link: "/reports" },
        {
          id: "User",
          title: "User Reports",
          link: "/user-reports",
        }
      ],
    },
    // {
    //   id: 'RevenueReports',
    //   title: 'Revenue Reports',
    //   link: '/revenue-reports',
    //   icon: 'mdi:report-multiple',
    // },
    {
      id: 'Pages',
      title: 'All Pages',
      link: '/allpages',
      icon: 'bx:file',
    },
    {
      id: "ProfileSettings",
      title: "Profile Settings",
      link: "/profile-settings",
      icon: "solar:settings-outline",
    },
  ];

  useEffect(() => {
    const currentPage = pages.find(
      (page) => page.submenu && isSubmenuItemActive(page.submenu)
    );
    if (
      currentPage &&
      currentPage.submenu &&
      isSubmenuItemActive(currentPage.submenu)
    ) {
      setOpenSubmenu(currentPage.id);
    } else {
      setOpenSubmenu(null);
    }
  }, [location.pathname]);

  return (
    <>
      <button
        onClick={toggleSidebar}
        className="btnopen"
        style={{ display: "none" }}
      >
        <Icon icon="solar:hamburger-menu-broken" />
      </button>
      <button
        className={
          sidebarOpen ? "btnclose sidebarbg-open" : "btnclose sidebarbg-closed"
        }
        style={{ display: "none" }}
        onClick={toggleSidebar}
      ></button>

      <div
        className={
          sidebarOpen ? "sidebar sidebar-open" : "sidebar sidebar-closed"
        }
      >
        <div className="sidebarlogo_div">
          <Link to="/dashboard">
            <img src={logowhite} alt="Logo" />
          </Link>
        </div>
        <div className="sidebarouter">
          {pages.map((page) => (
            <div key={page.id} className="navitem-container">
              <NavLink
                to={page.link}
                className={`navitem ${isPageActive(page) ? "active" : ""}`}
                onClick={
                  page.submenu
                    ? (e) => {
                        e.preventDefault();
                        handleSubmenuClick(page.id);
                      }
                    : handleNavLinkClick
                }
              >
                <div className="flex-grow-1">
                  <Icon icon={page.icon} />
                  {page.title}
                </div>
                {page.submenu && (
                  <Icon
                    icon={
                      openSubmenu === page.id
                        ? "mdi:chevron-up"
                        : "mdi:chevron-down"
                    }
                    className={`submenu-icon me-0 ${
                      openSubmenu === page.id ? "open" : ""
                    }`}
                  />
                )}
              </NavLink>
              {page.submenu && openSubmenu === page.id && (
                <div className="submenu">
                  {page.submenu.map((sub) => (
                    <NavLink
                      key={sub.id}
                      to={sub.link}
                      className="submenu-item"
                      onClick={handleNavLinkClick}
                    >
                      {sub.title}
                    </NavLink>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Sidebar;
